<template>
  <div class="container mt-2 mt-md-0">
    <div class="flex-container">
      <div
        class="flex-items"
      >
        <h4
          v-if="broker.brokerLogo == ''"
          class="brokerTitle mt-1 mt-md-0"
        >
          {{ broker.brokerCompanyName }}
        </h4>

        <img
          v-if="broker.brokerLogo != ''"
          :src="broker.brokerLogo"
          :alt="broker.brokerCompanyName"
          width="200"
          class="brokerLogo"
        >
      </div>
    </div>

    <div class="flex-container mt-2 mt-md-0">
      <div class="flex-items">
        <a
          :href="`https://${broker.websiteForDisplay}`"
          target="_blank"
          class="text-lowercase brokerInfo"
        >{{ broker.websiteForDisplay }}</a>
      </div>
      <div class="flex-items">
        <a
          :href="`tel:${ broker.telephoneForDisplay}`"
          class="text-lowercase brokerInfo"
        >{{ broker.telephoneForDisplay }}</a>
      </div>
      <div class="flex-items">
        <a
          :href="`mailto:${ broker.emailForDisplay}`"
          class="text-lowercase brokerInfo"
        >{{ broker.emailForDisplay }}</a>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'Broker',
		data() {
			return {
				broker: this.$broker
			}
		}
	}
</script>

<style lang="scss" scoped>
	.flex-container {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-end;
		align-items: stretch;
		align-content: space-between;

		@media screen and (max-width: 600px) {
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
	}

	.flex-items {
		display: block;
		flex-grow: 0;
		flex-shrink: 1;
		flex-basis: auto;
		align-self: auto;
		order: 0;
		padding-left: 10px;

		@media screen and (max-width: 600px) {
			padding-left: unset;
		}
	}

	.brokerTitle {
		padding: unset;
	}
</style>
